module.exports = __webpack_public_path__ + "static/media/profile.c7885f53.png";